import React from "react";
import "./spinner.css";

export default function LoadingSpinner() {
    const message = "We'll let you in once mediator will start that debate"
    return (
        
       
        <div className="spinner-container">
        <div className="spinner"></div>
        <p className="spinner-message">{message}</p>
      </div>

           


        
    );
  }